import { postRequest, getRequest, signupPostRequest } from "./ApiRequest";
import setAuthToken from "../config/setAuthToken";
import jwt_decode from "jwt-decode";
import { _auth } from "./_auth";
import { usePersistStore } from "../store/usestore";

export const templates = {
  profile() {
    return _auth.getUserProfile();
  },

  async saveFormTemplate(data) {
    console.log("Call API and pass data", data);
    let profile = this.profile();
    let token = localStorage.getItem("jwtToken");
    setAuthToken(token.replace(/"([^"]+(?="))"/g, "$1"));
    const body = {};
    body.name = "Template Name";
    body.description = "Template Description";
    body.json = data;
    body.form = data;
    body.tenantId = profile.tenantId;
    body.companyId = profile.companyId;
    console.log("API body", body);
    let response = await postRequest("templates/create", body);
    if (response) {
      return response;
    } else {
      return response;
    }
  },
  async getAllTemplates() {
    const body = {};
    console.log("Getting templates list");
    let token = localStorage.getItem("jwtToken");
    setAuthToken(token.replace(/"([^"]+(?="))"/g, "$1"));
    let response = await postRequest("templates/list", body);
    if (response) {
      return response.data.data;
    } else {
      return response;
    }
  },
  async getFormData(id) {
    const body = {};
    body.id = id;
    let token = localStorage.getItem("jwtToken");
    setAuthToken(token.replace(/"([^"]+(?="))"/g, "$1"));
    let response = await postRequest("templates/get-by-id", body);
    if (response) {
      return response.data.data;
    } else {
      return response;
    }
  },
};
